import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import { AuthContext } from '../../context/AuthContext';
import { VendedorContext } from '../../context/VendedorContext';
import { VendedorType, CreateVendedorType, EditVendedorType } from '../../context/hooks/useVendedor';
import useUser from '../../context/hooks/useUser';
import { createPermissionChecker, PermissionModule } from '../../types/permissions';
import ModalConfirm from '../../components/ModalConfirm/ModalConfirm';

const Vendedor = () => {
    const { objUserTk } = useContext(AuthContext);
    const { createVendedor, getVendedorPaged, updateVendedor, deleteVendedor, listVendedor, pageCount} = useContext(VendedorContext);
    const { getPermissionsByUser, userPermissions, useLegacyPermissions, modulePermissions } = useUser();
    const hasPermission = createPermissionChecker(useLegacyPermissions, userPermissions, modulePermissions);
    const [loaging, setLoading] = useState(true);
    const [newVendedor, setNewVendedor] = useState<CreateVendedorType>({
        name: '', empresaId: objUserTk.EmpresaId
    });
    const [editingVendedor, setEditingVendedor] = useState<EditVendedorType | null>(null);
    const [dataSearch, setDataSearch] = useState({ name: '' });
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    useEffect(() => {
        setLoading(true);

        getVendedorPaged(1, "", objUserTk.EmpresaId, 9)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar vendedores:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getVendedorPaged(value, dataSearch.name, objUserTk.EmpresaId, 9);
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataSearch({ ...dataSearch, name: e.target.value });
    };

    const handleSearchButtonClick = () => {
        setLoading(true);
        getVendedorPaged(1, dataSearch.name,objUserTk.EmpresaId, 9)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleClearFilters = () => {
        setDataSearch({ name: '' });
        setLoading(true);
        getVendedorPaged(1, "", objUserTk.EmpresaId, 9)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };


    const handleCreateInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setNewVendedor(prevVendedor => ({
                ...prevVendedor,
                [name]: checked,
            }));
        } else {
            setNewVendedor(prevVendedor => ({
                ...prevVendedor,
                [name]: value,
            }));
        }
    };

    const handleCreateVendedor = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        createVendedor(newVendedor)
            .then(createdVendedor => {
                if (createdVendedor) {
                    setCreateModalOpen(false);
                    setNewVendedor({
                        name: '', empresaId: objUserTk.EmpresaId
                    });
                    getVendedorPaged(1, "", objUserTk.EmpresaId, 9);
                } else {
                    console.error("Erro ao criar vendedor.");
                }
            })
            .catch(error => {
                console.error("Erro ao criar vendedor:", error);
            });
    };

    const handleEditInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;;
        setEditingVendedor(prevVendedor => ({
            ...prevVendedor!,
            [name]: type === 'checkbox' ? checked : value,
        }));
    }

    const handleEditVendedor = (vendedor: VendedorType) => {
        const updateData: EditVendedorType = {
            id: vendedor.id,
            name: vendedor.name,
        };
        setEditingVendedor(updateData);
        setEditModalOpen(true);
    };

    const handleEditSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (editingVendedor) {
            updateVendedor(editingVendedor)
                .then(updatedVendedor => {
                    if (updatedVendedor) {
                        setEditModalOpen(false);
                        getVendedorPaged(1, "", objUserTk.EmpresaId, 9);
                    } else {
                        console.error("Erro ao atualizar vendedor.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao atualizar vendedor:", error);
                });
        }
    };

    const [confirmDeleteVendedorId, setConfirmDeleteVendedorId] = useState<number | null>(null);

    const handleDeleteVendedor = (vendedorId: number) => {
        setConfirmDeleteVendedorId(vendedorId);
    };

    const executeDeleteVendedor = () => {
        if (confirmDeleteVendedorId == null) return;
        deleteVendedor(confirmDeleteVendedorId)
            .then(() => {
                setTimeout(() => {
                    getVendedorPaged(1, "", objUserTk.EmpresaId, 9);
                }, 500);
            })
            .catch(error => console.error("Erro ao excluir vendedor:", error));
        setConfirmDeleteVendedorId(null);
    };
    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Gerenciar Vendedores"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                <Row className="align-items-center mb-4">
                    <Col xs="12" md="9" lg="9" className="mb-2">
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="search"
                            id="search"
                            placeholder="Buscar por nome"
                            value={dataSearch.name}
                            onChange={handleSearchChange}
                        />
                    </Col>
                    <Col xs="12" md="3" lg="3" className="d-flex justify-content-start justify-content-md-end mb-2">
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                            type="button"
                            size="m"
                            onClick={handleSearchButtonClick}
                            className="mr-2"
                        >
                            Buscar
                        </Button>
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                            type="button"
                            size="m"
                            onClick={handleClearFilters}
                        >
                            Limpar
                        </Button>
                    </Col>
                    {hasPermission(PermissionModule.Vendas, 1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                size="m"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar vendedor
                            </Button>
                        </Col>
                    )}
                </Row>

                {hasPermission(PermissionModule.Vendas, 2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Editar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listVendedor.map((vendedor: VendedorType, index: number) => (
                                        <tr key={index}>
                                            <td>{vendedor.name}</td>
                                            <td>
                                                {hasPermission(PermissionModule.Vendas, 3) && (
                                                    <Button onClick={() => handleEditVendedor(vendedor)}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                )}
                                                {hasPermission(PermissionModule.Vendas, 4) && (
                                                    <Button onClick={() => handleDeleteVendedor(vendedor.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-end mt-3">
                                {pageCount > 0 ? (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={pageCount}
                                        />
                                    </div>
                                ) : null}
                                {listVendedor.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar os vendedores.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <Modal isOpen={createModalOpen} toggle={() => {
                setCreateModalOpen(!createModalOpen);
                setNewVendedor({
                    name: '', empresaId: objUserTk.EmpresaId
                });
            }} backdrop="static" size="lg">
                <ModalHeader toggle={() => setCreateModalOpen(!createModalOpen)}>Adicionar novo vendedor</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleCreateVendedor}>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="name">Nome</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="text"
                                        name="name"
                                        id="name"
                                        value={newVendedor.name}
                                        placeholder="Nome"
                                        onChange={handleCreateInputChange}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end mt-4">
                            <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Criar vendedor</Button>
                            <Button style={{ color: "#FFF", backgroundColor: "#d9534f" }} className="ml-2" onClick={() => {
                                setCreateModalOpen(false);
                                setNewVendedor({
                                    name: '', empresaId: objUserTk.EmpresaId
                                });
                            }} size="m">Cancelar</Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>

            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(!editModalOpen)} backdrop="static" size="lg">
                <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>Alterar informações do vendedor</ModalHeader>
                <ModalBody>
                    {editingVendedor && (
                        <Form onSubmit={handleEditSubmit}>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="name">Nome</Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="text"
                                            name="name"
                                            id="name"
                                            value={editingVendedor?.name || ''}
                                            placeholder="Nome"
                                            onChange={handleEditInputChange}
                                            required
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-end">
                                <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Salvar alterações</Button>
                                <Button style={{ color: "#FFF", backgroundColor: "#d9534f" }} className="ml-2" onClick={() => {
                                    setEditModalOpen(false);
                                }} size="m">Cancelar</Button>
                            </div>
                        </Form>
                    )}
                </ModalBody>
            </Modal>

            <ModalConfirm
                openModal={confirmDeleteVendedorId !== null}
                closeModal={() => setConfirmDeleteVendedorId(null)}
                handleConfirm={executeDeleteVendedor}
                title="Excluir vendedor"
                message="Tem certeza que deseja excluir este vendedor? Esta ação não pode ser desfeita."
            />
        </>
    );
};

export default Vendedor;